import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  margin-bottom: 24px;

  ${mediaQueries.tablet} {
    margin-bottom: 56px;
  }
`

export const DataContainer = styled.div`
  padding-bottom: 16px;
  overflow-x: scroll;
`

export const SingleVariantContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`

export const SingleVariantItem = styled.div`
  display: flex;
  align-items: center;
`

export const SingleVariantLabel = styled.div`
  font-size: 16px;
  margin-right: 3px;
  line-height: 24px;
`

export const WeightInputWrapper = styled.div`
  display: flex;
  margin-left: 8px;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 24px;

  & > * + * {
    margin-top: 16px;
  }
`

export const FooterInputContainer = styled.div`
  margin-top: 12px;
`
